import React, { useState } from 'react';
import { useDispatch } from 'react-redux'
import { useLocation } from "react-router-dom";
import { RegistrationForm } from '../components'
import { registerAsync } from '../app/userSlice'

export const Registration = ({ history }) => {
    const dispatch = useDispatch();  
    const paramLocationData = useLocation();
    const [regType, setRregType] = useState('custFacilityNumber');//custFacilityEmail
    const handleRegistration = (data, reset) => {
        dispatch(registerAsync(data, history, reset));
    }
    return <RegistrationForm onSubmit={handleRegistration} regType={regType} setRregType={setRregType} logEmail={paramLocationData?.state?.dynParam?.email.trim()} history={history}/>
}